import {ReactNode, useEffect} from 'react';

// material-ui
import {CacheProvider} from '@emotion/react';
import createCache, {StylisPlugin} from '@emotion/cache';

// third-party
import rtlPlugin from 'stylis-plugin-rtl';
import useConfigContext from "context/useConfigContext";

// project impor

// ==============================|| RTL LAYOUT ||============================== //

interface Props {
    children: ReactNode;
}

const RTLLayout = ({children}: Props) => {
    const {themeDirection} = useConfigContext();

    useEffect(() => {
        document.dir = themeDirection;
    }, [themeDirection]);

    const cacheRtl = createCache({
        key: themeDirection === 'rtl' ? 'rtl' : 'css',
        prepend: true,
        stylisPlugins: themeDirection === 'rtl' ? [rtlPlugin as unknown as StylisPlugin] : []
    });

    return <CacheProvider value={ cacheRtl }>{ children }</CacheProvider>;
};

export default RTLLayout;
